/**
 * =============================================================================
 * Blog Utilities - Blog-Specific Helpers
 * 
 * Contains utilities for the blog section only:
 * - Relative date formatting
 * - Draft preview loading
 * - Blog-specific helpers
 * 
 * Note: Squiggle system is now global via sc-squiggle.js
 * =============================================================================
 */

const DAY_MS = 24 * 60 * 60 * 1000;

// -------------------------------------------------------------------------
// Date Utilities
// -------------------------------------------------------------------------

function parseISODate(value) {
  if (!value) return null;
  if (value instanceof Date) return new Date(value.getTime());
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
}

function formatRelativeDate(dateInput, nowInput = new Date()) {
  const date = parseISODate(dateInput);
  const now = parseISODate(nowInput) || new Date();
  if (!date) return '';

  const diffMs = now.getTime() - date.getTime();
  if (!Number.isFinite(diffMs)) return '';
  if (diffMs <= 0) return 'today';

  const diffDays = Math.floor(diffMs / DAY_MS);
  if (diffDays <= 0) return 'today';
  if (diffDays === 1) return '1 day ago';
  if (diffDays < 7) return `${diffDays} days ago`;

  const diffWeeks = Math.floor(diffDays / 7);
  if (diffWeeks === 1) return '1 week ago';
  if (diffWeeks < 5) return `${diffWeeks} weeks ago`;

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths === 1) return '1 month ago';
  if (diffMonths < 12) return `${diffMonths} months ago`;

  const diffYears = Math.floor(diffDays / 365);
  if (diffYears === 1) return '1 year ago';
  return `${diffYears} years ago`;
}

function applyRelativeTime(timeEl, nowInput = new Date()) {
  if (!timeEl || !timeEl.getAttribute) return '';
  const datetime = timeEl.getAttribute('datetime');
  const label = formatRelativeDate(datetime, nowInput);
  if (!label) return '';
  if (!timeEl.dataset.absolute) {
    timeEl.dataset.absolute = timeEl.textContent || '';
  }
  timeEl.textContent = label;
  return label;
}

// -------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------

const api = {
  applyRelativeTime,
  formatRelativeDate,
  parseISODate
};

if (typeof module !== 'undefined') {
  module.exports = api;
}

if (typeof window !== 'undefined') {
  window.SnowcubesBlogUtils = api;
}
